
import { defineComponent, onMounted, ref, watch } from "vue";
import Chart from "chart.js/auto";

export default defineComponent({
  name: "BarChart",
  props: {
    data: {
      type: Object as () => {
        labels: string[];
        currentWeek: number[];
        previousWeek: number[];
        previousWeekLabels: string[];
      },
      required: true,
    },
  },

  setup(props) {
    const chartRef = ref<HTMLCanvasElement | null>(null);
    let chartInstance: Chart | null = null;

    const renderChart = () => {
      if (!chartRef.value) return;

      if (chartInstance) {
        chartInstance.destroy();
      }

      chartInstance = new Chart(chartRef.value, {
        type: "bar",
        data: {
          labels: props.data.labels,
          datasets: [
            {
              type: "bar",
              label: "Acesso atual",
              data: props.data.currentWeek,
              backgroundColor: "rgba(54, 162, 235, 0.6)",
              borderColor: 'rgba(54, 162, 235, 1)',
              borderRadius: 4,
              borderWidth: 3,
              tension: 0.4,
            },
            {
              type: "line",
              label: "Semana passada",
              data: props.data.previousWeek,
              borderColor: "#FF6384",
              backgroundColor: "rgba(255, 99, 132, 0.3)",
              tension: 0.4,
              fill: false,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            tooltip: {
              callbacks: {
                title: (tooltipItems) => {
                  const item = tooltipItems[0];
                  const index = item.dataIndex;
                  const datasetIndex = item.datasetIndex;

                  if (datasetIndex === 1) {
                    return `${props.data.previousWeekLabels[index]}`;
                  }

                  return item.label;
                },
              },
            },
            legend: {
              labels: {
                usePointStyle: false,
                boxWidth: 35,
                boxHeight: 12,
                padding: 20,
                font: {
                  size: 14,
                },
                color: '#333',
              },
            },
          },
          scales: {
            y: {
              min: 0,
              max: 1,
              ticks: {
                stepSize: 1,
              },
            },
          },
        },
      });
    };

    onMounted(() => {
      renderChart();
    });

    watch(
        () => props.data,
        () => {
          renderChart();
        },
        { deep: true }
    );

    return {
      chartRef,
    };
  },
});
